import type { ToastOptions } from 'vant'
import { showLoadingToast, setToastDefaultOptions } from 'vant'

export interface LoadingType {
    openLoading: (param?: ToastOptions) => void
    closeLoading: () => void
}

const getLoading = (): LoadingType => {
    setToastDefaultOptions('loading', {
        forbidClick: true,
        // overlay: true,
        duration: 0,
    })

    let toastLoading: any = null

    const openLoading = (param: ToastOptions = { message: '加载中...' }) => {
        toastLoading = showLoadingToast(param)
    }

    const closeLoading = () => {
        toastLoading && toastLoading.close()
    }

    return {
        openLoading,
        closeLoading,
    }
}

export const $loading = getLoading()
